import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { usePainelPublico } from "../../../hooks/usePainelPublico";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import MapaGoogle from "../../../components/MapaGoogle";
import { actionGetDashboardGeralPublico } from "../../../features/(ApiKey)/Mapa/get/slices";
import "./style.scss";
import { LoaderCircle } from "lucide-react";

const PageMapaPublico = () => {
  const dispatch = useAppDispatch();
  const { apiKey, status, data } = usePainelPublico();
  const dashboard = useAppSelector((state) => state.getDashboardGeralPublico);

  const logosRef = React.useRef<string[]>([]);
  if (data?.logos?.length) {
    logosRef.current = data.logos;
  }
  const logos = data?.logos || [];

  const statusBrasil = React.useMemo(() => {
    return (
      dashboard.data?.mapaBrasil?.reduce((acc: any, item: any) => {
        return { ...acc, [item.sigla.toLowerCase()]: item.status };
      }, {}) || {}
    );
  }, [dashboard.data]);

  useEffect(() => {
    if (status !== "ready" || !apiKey) return;

    const fetch = () => {
      dispatch(actionGetDashboardGeralPublico(apiKey));
    };

    fetch();
    const interval = setInterval(fetch, 60000);
    return () => clearInterval(interval);
  }, [status, apiKey, dispatch]);

  if (status === "unauthorized") {
    return (
      <div
        className="center-object-screen"
        style={{
          flexDirection: "column",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <h2>Acesso não autorizado</h2>
        <p>
          Link inválido ou expirado. Solicite um novo link ao administrador.
        </p>
      </div>
    );
  }

  if (status === "loading" || dashboard.status === "loading") {
    return (
      <div className="center-object-screen">
        <LoaderCircle className="loader" />
      </div>
    );
  }

  return (
    <div>
      {logos &&
        logos.length > 0 &&
        ReactDOM.createPortal(
          <div className="logos">
            {logos.map((logoUrl: string, index: number) => (
              <img
                className="logo"
                key={index}
                src={logoUrl}
                alt={`Logo ${index + 1}`}
              />
            ))}
          </div>,
          document.body,
        )}
      <MapaGoogle
        fillScreen={true}
        status={statusBrasil}
        lojasMapa={dashboard.data?.lojasMapa || []}
        zoom={5}
      />
    </div>
  );
};

export default PageMapaPublico;
